<template>
  <div class="hello" v-if="hasLoad">
    <!-- 设置区域 开始 -->
    <!-- <el-form ref="form"  label-width="80px"> -->
    <el-row>
      <el-col :span="6">
        <!-- 日期范围设置 -->
        <el-form-item label="日期范围">
          <el-col :span="11">
            <el-date-picker type="date" placeholder="开始日期" v-model="setData.startDate" style="width: 100%;" @change="dateInitLoadDate()"></el-date-picker>
          </el-col>
          <el-col class="line" :span="2">-</el-col>
          <el-col :span="11">
            <el-date-picker type="date" placeholder="结束日期" v-model="setData.endDate" style="width: 100%;" @change="dateInitLoadDate()"></el-date-picker>
          </el-col>
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <!-- 时段范围设置 -->
        <el-form-item label="上下晚起始">
          <el-col :span="11">
            <el-time-picker placeholder="上午开始" v-model="setData.startTime" value-format="HH:mm" format="HH:mm" style="width: 100%;" @change="intervalInitLoadDate()"></el-time-picker>
          </el-col>
          <el-col class="line" :span="2">-</el-col>
          <el-col :span="11">
            <el-time-picker placeholder="下午开始" v-model="setData.downStartTime" value-format="HH:mm" format="HH:mm" style="width: 100%;" @change="intervalInitLoadDate()"></el-time-picker>
            <!-- <el-time-picker placeholder="结束时段" v-model="setData.endTime" value-format="HH:mm" format="HH:mm" style="width: 100%;" @change="intervalInitLoadDate()"></el-time-picker> -->
          </el-col>
          <el-col :span="11">
            <el-time-picker placeholder="晚上开始" v-model="setData.nightStartTime" value-format="HH:mm" format="HH:mm" style="width: 100%;" @change="intervalInitLoadDate()"></el-time-picker>
            <!-- <el-time-picker placeholder="结束时段" v-model="setData.endTime" value-format="HH:mm" format="HH:mm" style="width: 100%;" @change="intervalInitLoadDate()"></el-time-picker> -->
          </el-col>
        </el-form-item>
      </el-col>
      <el-col :span="4">
        <!-- 时段时长设置 -->
        <el-form-item label="时段间隔">
          <el-input-number v-model="setData.minutesInterval" @change="intervalInitLoadDate()"></el-input-number>
        </el-form-item>
      </el-col>
      <el-col :span="4">
        <!-- 时段时长设置 -->
        <el-form-item label="单课时时长">
          <el-input-number v-model="setData.minutesLength" @change="initLoadDate()"></el-input-number>
        </el-form-item>
      </el-col>
      <!-- 横纵显示设置
      <el-col :span="4">
        <el-form-item label="横纵切换">
          <el-switch v-model="setData.hvType" @change="initLoadDate()"></el-switch>
        </el-form-item>
      </el-col> -->
    </el-row>
    <!-- </el-form> -->
    <!-- 设置区域 结束 -->
    <!-- 课程区域 开始 -->
    <el-form style="width: 30%;float:left;" ref="form" size="mini"  label-width="80px">
      <!-- <div :style="('padding: 0 10px 0 10px;margin:10px 0 0 20px;')+'position: relative;background:#fff;border: 1px solid green;width:-webkit-fill-available;overflow-x: hidden;'+ (value.fieldSet[scheduleIndex-1].styleSet.pageFieldStyleSet?value.fieldSet[scheduleIndex-1].styleSet.pageFieldStyleSet.styleSetCode:'')">
        <el-row :gutter="10" style="display: inline-flex;margin-left: 5px;width: 100%;"  >
          <template v-for="(childFieldOne,childFieldIndex) in value.fieldSet[scheduleIndex-1].childFieldSet">
            <el-col v-if="childFieldOne.fieldRole != 30 && childFieldOne.childHeadHide!=1" style="min-width:150px;padding-left: 20px;" :key="'childHeadField_'+childFieldIndex" :xs="Math.ceil(childFieldOne.colSpan*(24/(value.fieldSet[scheduleIndex-1].childMaxCol+1)))" :sm="Math.ceil(childFieldOne.colSpan*(24/(value.fieldSet[scheduleIndex-1].childMaxCol+1)))" :md="Math.ceil(childFieldOne.colSpan*(24/(value.fieldSet[scheduleIndex-1].childMaxCol+1)))" :lg="Math.ceil(childFieldOne.colSpan*(24/(value.fieldSet[scheduleIndex-1].childMaxCol+1)))" :xl="Math.ceil(childFieldOne.colSpan*(24/(value.fieldSet[scheduleIndex-1].childMaxCol+1)))"  v-show="!childFieldOne.ifHide">
              {{childFieldOne.fieldCnName}}
            </el-col>
          </template>
        </el-row>
      </div>
      <div v-for="(childOne,childIndex) in value.fieldSet[scheduleIndex-1].childPageJsonArr" :key="'childLook_'+childIndex+'_'+childOne.defaultIdStr+'_'+childOne.updateDataId" :ref="'childDivBox_'+0 + '_' + childIndex"
          :style="('padding: 0 10px 0 10px;margin:10px 0 0 20px;')+'position: relative;background:#fff;border: 1px solid green;overflow-x: auto;'+ (value.fieldSet[scheduleIndex-1].styleSet.pageFieldStyleSet?value.fieldSet[scheduleIndex-1].styleSet.pageFieldStyleSet.styleSetCode:'')" kwName="pageFieldStyleSet">
        <span style="position: absolute;font-size: 12px;margin-right:5px;top:5px;left: 2px;color: red;">{{childIndex+1}}</span>
        <kw_look :ref="('kw_look_'+value.fieldSet[scheduleIndex-1].fieldId + '_' + childIndex)" :class="('kw_look_'+value.fieldSet[scheduleIndex-1].fieldId)" :initMainId="childOne.updateDataId" :initPageSetInfo="childOne" :ifChild="1"   :nowDataIndex="childIndex+''" ></kw_look>
      </div> -->
      <div :style="'height:'+(windowHeight-200)+'px;overflow: auto;'">
        <div v-for="(childOne,childIndex) in value.fieldSet[scheduleIndex-1].childPageJsonArr" :key="'childLook_'+childIndex+'_'+childOne.defaultIdStr+'_'+childOne.updateDataId">
          <div v-if="childIndex==0 || childOne.fieldSet[0].defaultValStr != value.fieldSet[scheduleIndex-1].childPageJsonArr[childIndex-1].fieldSet[0].defaultValStr" style="border-top: 1px solid;font-weight: bold;">{{childOne.fieldSet[0].fieldCnName}}:{{childOne.fieldSet[0].defaultValStr}},总课时:{{courseList[childIndex].COURSE_MAX_HOUR}},已排课时:{{courseList[childIndex].ORDER_PLAN_HOUR}}</div>
          <div style="padding:0 0 0 20px;border: 1px solid;margin: 1px;">
            <div style="display:flex;">
              <el-radio v-model="currentRowIndex" @change="courseCurrentChange" :label="childIndex" style="line-height:unset;margin-right: 10px;">{{childIndex+1}}</el-radio>
              <div v-if="childOne.fieldSet[1].zdyAliasName == 'COURSE_ID'" style="color: #fd0e0e;">{{childOne.fieldSet[1].defaultValStr}}:</div>
              <div><span>已排课时:{{courseList[childIndex].COURSE_PLAN_HOUR?courseList[childIndex].COURSE_PLAN_HOUR:0}}</span>/单课时分钟:{{childOne.fieldSet[3].defaultValStr}}/课次课时:<input v-model="childOne.fieldSet[4].defaultValStr" @change="refreshCourstList(childOne.fieldSet[4],childIndex)" style="width: 60px;border: 1px solid #60fb08;height: 15px;"/></div>
            </div>
            <template v-for="(fieldSetOne,fieldSetIndex) in childOne.fieldSet" >
              <kw_dialog_field v-if="fieldSetOne.zdyAliasName == 'TEA_ID'" :key="'tea_room_field_'+fieldSetIndex" v-model="childOne.fieldSet[fieldSetIndex]" :ref="('field_'+fieldSetIndex)" :id="('field_'+fieldSetIndex)"  :nowDataId="(childOne.fieldSet[fieldSetIndex].defaultCheckValue)" :filedIndex="childOne.fieldSet[fieldSetIndex].prevFieldIndex+':'+childOne.fieldSet[fieldSetIndex].nowFieldIndex+'-'+childIndex"  :pageSetInfo="childOne" :nowDataIndex="childIndex+''" @dialogFieldCallBack="(fieldOne)=>teaChangeCallBack(fieldOne,childIndex)" ></kw_dialog_field>
              <kw_dialog_field v-else-if="fieldSetOne.zdyAliasName == 'ROOM_ID'" :key="'tea_room_field_'+fieldSetIndex" v-model="childOne.fieldSet[fieldSetIndex]" :ref="('field_'+fieldSetIndex)" :id="('field_'+fieldSetIndex)"  :nowDataId="(childOne.fieldSet[fieldSetIndex].defaultCheckValue)" :filedIndex="childOne.fieldSet[fieldSetIndex].prevFieldIndex+':'+childOne.fieldSet[fieldSetIndex].nowFieldIndex+'-'+childIndex"  :pageSetInfo="childOne" :nowDataIndex="childIndex+''" @dialogFieldCallBack="(fieldOne)=>roomChangeCallBack(fieldOne,childIndex)" ></kw_dialog_field>
            </template>
          </div>
        </div>
      </div>
      
      
      <!-- <el-table v-if="ifLoad" ref="courseTable" :data="courseList" :height="(windowHeight-200)" border size="mini" stripe >
        <el-table-column type="selection" width="35"></el-table-column>
        <el-table-column width="80" label="排课课程">
          <template slot-scope="scope">
            <el-radio v-model="currentRowIndex" @change="courseCurrentChange" :label="scope.$index">{{scope.$index+1}}</el-radio>
          </template>
        </el-table-column>
        <el-table-column v-for="(headOne,headIndex) in courseHead" :key="headIndex" :prop="headOne.prop" :label="headOne.label" :width="(headOne.prop=='TEA_ID'||headOne.prop=='ROOM_ID')?200:80">
          <template slot-scope="scope">
            <kw_dialog_field v-if="headOne.prop=='TEA_ID'" v-model="value.fieldSet[scheduleIndex-1].childPageJsonArr[scope.$index].fieldSet[headIndex]" :ref="('field_'+headIndex)" :id="('field_'+headIndex)"  :nowDataId="(value.fieldSet[scheduleIndex-1].childPageJsonArr[scope.$index].fieldSet[headIndex].defaultCheckValue)" :filedIndex="value.fieldSet[scheduleIndex-1].childPageJsonArr[scope.$index].fieldSet[headIndex].prevFieldIndex+':'+value.fieldSet[scheduleIndex-1].childPageJsonArr[scope.$index].fieldSet[headIndex].nowFieldIndex+'-'+scope.$index"  :pageSetInfo="value.fieldSet[scheduleIndex-1].childPageJsonArr[scope.$index]" :nowDataIndex="scope.$index+''" @dialogFieldCallBack="(fieldOne)=>teaChangeCallBack(fieldOne,scope.$index)" ></kw_dialog_field>
            <kw_dialog_field v-else-if="headOne.prop=='ROOM_ID'" v-model="value.fieldSet[scheduleIndex-1].childPageJsonArr[scope.$index].fieldSet[headIndex]" :ref="('field_'+headIndex)" :id="('field_'+headIndex)"  :nowDataId="(value.fieldSet[scheduleIndex-1].childPageJsonArr[scope.$index].fieldSet[headIndex].defaultCheckValue)" :filedIndex="value.fieldSet[scheduleIndex-1].childPageJsonArr[scope.$index].fieldSet[headIndex].prevFieldIndex+':'+value.fieldSet[scheduleIndex-1].childPageJsonArr[scope.$index].fieldSet[headIndex].nowFieldIndex+'-'+scope.$index"  :pageSetInfo="value.fieldSet[scheduleIndex-1].childPageJsonArr[scope.$index]" :nowDataIndex="scope.$index+''" @dialogFieldCallBack="(fieldOne)=>roomChangeCallBack(fieldOne,scope.$index)" ></kw_dialog_field>
            <input v-else-if="headOne.prop=='COURSE_BOUT_HOUR'" v-model="scope.row[headOne.prop]" style="width: 80px;border: 1px solid #60fb08;"/>
            <span v-else>{{scope.row[headOne.prop]}}</span>
          </template>
        </el-table-column>
      </el-table> -->
    </el-form>
    <!-- 课程区域 结束 -->
    <!-- 显示区域 开始 -->
    <el-table v-if="ifLoad" :data="tableData" :height="(windowHeight-200)" border size="mini" stripe style="width: 70%" :row-style="rowStyleCount" :cell-style="rowStyleCount">
      <el-table-column v-for="(headOne,headIndex) in tableHead" :key="headIndex" :prop="headOne.prop" :label="headOne.label" :fixed="headOne.fixed" width="120">
        <template slot="header" slot-scope="scope">
          {{scope.column.label}} <i v-if="scope.column.label=='时段'" class="el-icon-circle-plus" @click="toAddTimeIntervalOne()" ></i>
        </template>
        <template slot-scope="scope">
          <div v-if="headOne.prop=='timeInterval'">
            <span style="" v-if="scope.row[headOne.prop]" >
              {{scope.row[headOne.prop]}} <i class="el-icon-circle-plus" @click="toAddTimeIntervalOne(scope.row[headOne.prop])" ></i>
              <i class="el-icon-remove" @click="toDeleteTimeIntervalOne(scope.$index)" ></i>
            </span>
          </div>
          <div v-else-if="scope.row['if_'+headOne.prop]" :style="scope.row[headOne.prop]&&headOne.prop!='timeInterval'?'background:' + (scope.row['ZD_IF_LEAVE_'+headOne.prop] == 1?'#78CBF7':'red') + ';position: absolute;top: ' + scope.row['top_'+headOne.prop] + 'px;left: 0;width: 100%;z-index: 1;height:'+scope.row['height_'+headOne.prop]+'px;':''" >
            <el-checkbox v-if="scope.row['ZD_IF_LEAVE_'+headOne.prop] == 1" v-model="scope.row['check_'+headOne.prop]" :style="scope.row[headOne.prop]&&headOne.prop!='timeInterval'?'margin-left: 10px;':''" @change="(value)=>clickCheckBox(value,headOne,scope.row)"></el-checkbox>
            <span style="margin-left: 10px;font-size: 10px;" v-if="scope.row[headOne.prop]">
              {{scope.row[headOne.prop]}}
            </span>
          </div>
          <div v-else :style="scope.row[headOne.prop]&&headOne.prop!='timeInterval'?'background:#82fb9c;position: absolute;top: ' + scope.row['top_'+headOne.prop] + 'px;left: 0;width: 100%;z-index: 1;height:'+scope.row['height_'+headOne.prop]+'px;':''" @click="changeScheduleRoom(headOne,scope.row)">
            <span @click.stop>
              <el-checkbox v-model="scope.row['check_'+headOne.prop]" :style="'z-index:2;'+(scope.row[headOne.prop]&&headOne.prop!='timeInterval'?'margin-left: 10px;':'')" @change="(value)=>clickCheckBox(value,headOne,scope.row)"></el-checkbox>
            </span>
            <span style="margin-left: 10px;font-size: 10px;" v-if="scope.row[headOne.prop]">
              {{scope.row[headOne.prop]}}
            </span>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <!-- 显示区域 结束 -->

    <el-dialog title="设置时段" :visible.sync="ifTimeSetDialog.flag">
      <el-time-select
        placeholder="时间点"
        v-model="toAddTime"
        :picker-options="{
          start: ifTimeSetDialog.startDate,
          step: '00:10',
          end: ifTimeSetDialog.endDate
        }">
      </el-time-select>
      <div slot="footer" class="dialog-footer">
        <el-button @click="toAddTimeIntervalOne()">取 消</el-button>
        <el-button type="primary" @click="addTimeIntervalOne()">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog v-if="nowOpenRoomScheduleInfo.ifLoad" title="确认教室" :visible.sync="nowOpenRoomScheduleInfo.ifLoad" width="30%" center>
      <!-- <span>{{scheduleData[nowOpenRoomScheduleInfo.scheduleIndex]}}</span> -->
      <div>{{scheduleData[nowOpenRoomScheduleInfo.scheduleIndex].SCHEDULE_COURSE_NAME}}</div>
      <div>{{scheduleData[nowOpenRoomScheduleInfo.scheduleIndex].START_DATE+'-'+scheduleData[nowOpenRoomScheduleInfo.scheduleIndex].END_DATE.split(' ')[1]}}</div>
      <!-- <div>{{scheduleData[nowOpenRoomScheduleInfo.scheduleIndex].END_DATE}}</div> -->
      教室:<el-select v-model="scheduleData[nowOpenRoomScheduleInfo.scheduleIndex].SCHEDULE_ROOM_ID" filterable placeholder="请输入关键词" clearable :loading="nowOpenRoomScheduleInfo.loading" @change="roomChange">
          <el-option
            v-for="goalTableOne in nowOpenRoomScheduleInfo.roomData"
            :key="goalTableOne['T_'+dataInfo.ROOM_CHOOSE_TABLE_ID+'_0']"
            :label="goalTableOne.ROOM_NAME"
            :value="goalTableOne['T_'+dataInfo.ROOM_CHOOSE_TABLE_ID+'_0']">
          </el-option>
      </el-select>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeChangeScheduleRoom">关 闭</el-button>
        <!-- <el-button type="primary" @click="confirmChangeScheduleRoom">确 定</el-button> -->
      </span>
    </el-dialog>
  </div>
</template>

<script>
// 弹出层组件
import kw_dialog_field from '@/components/look/kw_dialog_field.vue';
import pageUtils from '@/js/page/pageUtil.js';
import utils from '@/js/utils/util.js';
export default {
  name: 'KwMakeSchedule',
  props: {
    // 课程的主键信息
    courseIdKey:{
      type:String,
      default:"COURSE_ID",
    },
    // 可排的课程数据
    initCourseList:{
      type:Array,
      default:function(){
        return [];
      }
    },
    filedIndex:{
      type:String,
      default:""
    },
    // 已排课表数据
    initScheduleData:{
      type:Array,
      default:function(){
        return []
      }
    },
    // 第几个字段
    scheduleIndex:0,
    value: {
      type: Object,
      default: function(){
        return {};
      }
    },
    dataInfo:{
      type: Object,
      default: function(){
        return {};
      }
    }
  },
  data() {
    return {
      ifLoad:false,
      hasLoad:false,
      windowHeight:window.innerHeight,
      setData:{
        // 开始日期
        startDate:new Date(),
        // 结束日期
        endDate:new Date(),
        // 开始时段
        startTime:"06:20",
        downStartTime:"13:30",
        nightStartTime:'18:30',
        // 结束时段
        endTime:"22:00",
        // 时段间隔分钟
        minutesInterval:130,
        // 单课时时长
        minutesLength:60,
        // 横纵切换
        hvType:false,
        // 表格的默认高度
        rowHeight:100
      },  
      // 表头行信息
      tableHead:[],
      // 数据信息
      tableData:[],
      courseHead:[{
          prop:"COURSE_NAME",
          label:"课程名称",
          fixed:false
        },{
          prop:"TEA_ID",
          label:"教师",
          fixed:false
        },{
          prop:"ROOM_ID",
          label:"教室",
          fixed:false
        },{
          prop:"COURSE_MAX_HOUR",
          label:"总课时",
          fixed:false
        },{
          prop:"COURSE_MINUTES_LENGTH",
          label:"单课时分钟数",
          fixed:false
        },{
          prop:"COURSE_BOUT_HOUR",
          label:"课次课时",
          fixed:false
        },{
          prop:"COURSE_PLAN_HOUR",
          label:"已排课时",
          fixed:false
        }],
      courseList:[],
      // 课程当前的选中行
      currentRowIndex: 0,
      scheduleData:[],
      //时段的数组
      timeIntervalList:[],
      //教师的时间占用信息
      teaTimeSource:{

      },
      //教室的时间占用信息
      roomTimeSource:{

      },
      //是否打开时段设置的弹出层
      ifTimeSetDialog:{
        flag:false,
        startDate:"08:30",
        endDate:"22:00"
      },
      toAddTime:null,
      //打开的修改教室的弹出层信息
      nowOpenRoomScheduleInfo:{
        ifLoad:false,
        scheduleIndex:-1,
        roomData:[],
        loading:false
      }
    };
  },
  created() {
    
  },
  mounted() {
    var that = this;
    // 默认所有的课程都显示 courseTable
    var setData = this.setData;
    var endDate = new Date();
    endDate.setDate(endDate.getDate()+30);
    setData.endDate = endDate;
    var scheduleData = this.initScheduleData;
    scheduleData.forEach((scheduleOne, xhIndex) => {
      scheduleOne.STUDY_DATE = pageUtils.dateFormat(new Date(scheduleOne.STUDY_DATE),'yyyy-MM-dd');
      scheduleOne.START_DATE = pageUtils.dateFormat(new Date(scheduleOne.START_DATE),'yyyy-MM-dd HH:mm');
      scheduleOne.END_DATE = pageUtils.dateFormat(new Date(scheduleOne.END_DATE),'yyyy-MM-dd HH:mm');
    })
    that.scheduleData = scheduleData;
    var courseList = [];
    var orderMap = {};
    this.initCourseList.forEach((courseOne, xhIndex) => {
      var teaId = "";
      var teaName = "";
      if(typeof (courseOne.TEA_ID) == "object") {
        for (var j = 0; j < courseOne.TEA_ID.length; j++) {
          var teaOne = courseOne.TEA_ID[j];
          teaId = (teaId==""?"":",") + teaOne.T_2_0;
          teaName = (teaName==""?"":",") + teaOne.F_2_TEA_NAME;
        }
        courseOne.TEA_ID = teaId;
        courseOne.TEA_NAME = teaName;
      }
      var orderNum = "";
      var courseMaxNum = 0;
      var courseName = "";
      for(var key in courseOne){
        if(key.endsWith("ORDER_NUM")) {
          orderNum = courseOne[key];
        } else if(key.endsWith("COURSE_MAX_HOUR")){
          courseMaxNum = courseOne[key];
        } else if(key.endsWith("COURSE_ID_NAME")) {
          courseName = courseOne[key];
        }
      }
      courseOne.COURSE_MAX_HOUR = courseMaxNum;
      courseOne.ORDER_NUM = orderNum;
      if(!courseOne.COURSE_NAME) {
        courseOne.COURSE_NAME = courseName;
      }
      if(!courseOne.ROOM_NAME && courseOne.ROOM_ID_NAME) {
        courseOne.ROOM_NAME = courseOne.ROOM_ID_NAME;
      }
      //获取订单编号 获取订单的已排课时 ORDER_NUM
      if(!orderMap["ORDER_NUM_"+orderNum]) {
        orderMap["ORDER_NUM_"+orderNum] = 0;
      }
      orderMap["ORDER_NUM_"+orderNum] += courseOne.COURSE_PLAN_HOUR*1;
      courseList.push(courseOne);
    })
    courseList.forEach((courseOne, xhIndex) => {
      var orderNum = courseOne.ORDER_NUM;
      if(orderNum) {
        that.$set(courseOne,"ORDER_PLAN_HOUR", orderMap["ORDER_NUM_"+orderNum]?orderMap["ORDER_NUM_"+orderNum]:0);
      } else {
        that.$set(courseOne,"ORDER_PLAN_HOUR", courseOne.COURSE_PLAN_HOUR?courseOne.COURSE_PLAN_HOUR:0);
      }
    });
    console.log("courseList========================",courseList,orderMap);
    this.courseList = courseList;
    
    this.dateInitLoadDate();
    this.hasLoad = true;
  },
  watch:{
  },
  computed:{
  },
  components: {
    kw_dialog_field,
    kw_look:resolve => require(['@/components/look/kw_look.vue'], resolve),
  },
  methods: {
    refreshCourstList:function(childOne,childIndex){
      this.courseList[childIndex].COURSE_BOUT_HOUR = childOne.defaultValStr;
    },
    rowStyleCount:function(row,rowIndex){
      var heightNum = (this.setData.rowHeight * (row.row.minutesInterval/this.setData.minutesInterval))
      return "height:"+heightNum+"px;";
    },
    dateInitLoadDate:function(){
      this.getTeaTimeResource("TEA");
      this.getTeaTimeResource("ROOM");
      this.initLoadDate();
    },
    intervalInitLoadDate:function(){
      this.timeIntervalList = [];
      this.setData.rowHeight = 100;
      this.initLoadDate();
    },
    /**
     * 进行数据初始化加载
     */
    initLoadDate:function(){
      var that = this;
      this.ifLoad = false;
      //获取需要显示的时段进行时段数组的生成
      this.$nextTick(function(){
        that.loadTableHead();
        that.loadTableData();
        that.ifLoad = true;
      })
    },
    /**
     * 加载表头行
     */
    loadTableHead:function(){
      var setData = this.setData;
      var tableHead = [];
      if(setData.hvType) {
        // 时段作为表头行

      } else {
        // 日期作为表头行
        tableHead.push({
          prop:"timeInterval",
          label:"时段",
          fixed:true
        });
        var xhDate = new Date(setData.startDate);
        var endDate = new Date(setData.endDate);
        var show_day = new Array('一', '二', '三', '四', '五', '六', '日');
        while(pageUtils.dateFormat(xhDate, "yyyy-MM-dd") <= pageUtils.dateFormat(endDate, "yyyy-MM-dd")) {
          var weekDay = (xhDate.getDay()==0?7:xhDate.getDay())-1;
          tableHead.push({
            prop:"date_"+pageUtils.dateFormat(xhDate, "yyyy-MM-dd"),
            label:pageUtils.dateFormat(xhDate, "yyyy-MM-dd")+"(" + show_day[weekDay] + ")",
            date:pageUtils.dateFormat(xhDate, "yyyy-MM-dd"),
            fixed:false
          })
          xhDate.setDate(xhDate.getDate()+1);
        }
      }
      this.tableHead = tableHead;
    },
    /**
     * 加载表格数据
     */
    loadTableData:function(){
      var that = this;
      var setData = this.setData;
      var scheduleData = this.scheduleData;
      var tableData = [];
      
      if(setData.hvType) {
        // 时段作为表头行

      } else {
        // 日期作为表头行
        // var xhTime = new Date("2020-01-01 " + setData.startTime);
        // var endTime = new Date("2020-01-01 " + setData.endTime);
        //初始化 时段数组
        that.initTimeIntervalList();
        var timeIntervalList = that.timeIntervalList;
        console.log("timeIntervalList=======================",timeIntervalList);
        for (let index = 0; index < timeIntervalList.length; index++) {
          const xhTimeInteravlOne = timeIntervalList[index];
        // timeIntervalList.forEach(xhTimeInteravlOne => {
          var xhTime = new Date(xhTimeInteravlOne.xhTime);
          var minutesInterval = xhTimeInteravlOne.minutesInterval;
        // while(pageUtils.dateFormat(xhTime, "yyyy-MM-dd HH:mm") < pageUtils.dateFormat(endTime, "yyyy-MM-dd HH:mm")) {
          var startTimeStr = pageUtils.dateFormat(xhTime, "HH:mm");
          xhTime.setMinutes(xhTime.getMinutes()+minutesInterval);
          var endTimeStr = pageUtils.dateFormat(xhTime, "HH:mm");
          var tableDataOne = {
            "timeInterval":startTimeStr + "-" + endTimeStr,
            "minutesInterval":minutesInterval
          };
          //已排课时间段进行表格显示
          scheduleData.forEach((scheduleOne, xhIndex) => {
            var scheduleCourseId = scheduleOne.SCHEDULE_COURSE_ID;
            var scheduleStudyDate = scheduleOne.STUDY_DATE;
            var scheduleStartDate = scheduleOne.START_DATE;
            var scheduleEndDate = scheduleOne.END_DATE;
            var scheduleTimeStr = pageUtils.dateFormat(new Date(scheduleStartDate), "HH:mm") + "-" + pageUtils.dateFormat(new Date(scheduleEndDate), "HH:mm")
            var scheduleMinutes = scheduleOne.MINUTES;
            var scheduleHeight = setData.rowHeight*(scheduleMinutes/setData.minutesInterval);
            //判断时段在当前的表格内
            var scheduleStartDateStr = pageUtils.dateFormat(new Date(scheduleStartDate), "HH:mm");
            if(scheduleStartDateStr >= startTimeStr && scheduleStartDateStr < endTimeStr) {
              tableDataOne["if_date_"+scheduleStudyDate] = false;
              tableDataOne["date_"+scheduleStudyDate] = scheduleOne["SCHEDULE_COURSE_NAME"] + " " + scheduleStudyDate + " " + scheduleTimeStr + " " + (scheduleOne["SCHEDULE_TEA_NAME"]&&scheduleOne["SCHEDULE_TEA_NAME"]!='undefined'?scheduleOne["SCHEDULE_TEA_NAME"]:"") + " " + (scheduleOne["SCHEDULE_ROOM_NAME"]&&scheduleOne["SCHEDULE_ROOM_NAME"]!='undefined'?scheduleOne["SCHEDULE_ROOM_NAME"]:"");
              tableDataOne["index_"+scheduleStudyDate] = xhIndex;
              tableDataOne["height_date_"+scheduleStudyDate] = scheduleHeight;
              tableDataOne["check_date_"+scheduleStudyDate] = true;
              //距离顶部的距离 top
              var scheduleTop = 0;
              if(scheduleStartDateStr != startTimeStr) {
                let dateDiff = new Date('2021-01-01 '+ scheduleStartDateStr).getTime() - new Date('2021-01-01 '+startTimeStr).getTime();
                let topMinutes=Math.floor(dateDiff/(60*1000));
                scheduleTop = setData.rowHeight*(topMinutes/setData.minutesInterval);
              }
              tableDataOne["top_date_"+scheduleStudyDate] = scheduleTop;
            }
          });
          //教师的占用时间段进行表格显示
          that.showTeaTimeResource("TEA",tableDataOne,startTimeStr,endTimeStr);
          //教室的占用时间段进行表格显示
          that.showTeaTimeResource("ROOM",tableDataOne,startTimeStr,endTimeStr);
          tableData.push(tableDataOne);
        }
      }
      this.tableData = tableData;
      this.countCoursePlanHour();
    },
    //初始化 时段数组
    initTimeIntervalList:function(){
      var timeIntervalList = this.timeIntervalList;
      var setData = this.setData;
      var xhTime = new Date("2020-01-01 " + setData.startTime);
      var downStartTime = new Date("2020-01-01 " + setData.downStartTime);
      var nightStartTime = new Date("2020-01-01 " + setData.nightStartTime);
      var endTime = new Date("2020-01-01 " + setData.endTime);
      var ifReload = false;
      var minutesInterval = setData.minutesInterval;
      if(timeIntervalList.length == 0) {
        ifReload = true;
      } 
      if(ifReload) {
        timeIntervalList = [];
        while(pageUtils.dateFormat(xhTime, "yyyy-MM-dd HH:mm") < pageUtils.dateFormat(endTime, "yyyy-MM-dd HH:mm")) {
          var newDate = new Date(xhTime.getTime());
          timeIntervalList.push({
            xhTime:pageUtils.dateFormat(newDate, "yyyy-MM-dd HH:mm"),
            minutesInterval:setData.minutesInterval
          });
          xhTime.setMinutes(xhTime.getMinutes()+minutesInterval);
          if(pageUtils.dateFormat(downStartTime, "yyyy-MM-dd HH:mm") <= pageUtils.dateFormat(xhTime, "yyyy-MM-dd HH:mm") && pageUtils.dateFormat(downStartTime, "yyyy-MM-dd HH:mm") > pageUtils.dateFormat(newDate, "yyyy-MM-dd HH:mm")) {
            xhTime = downStartTime;
            let dateDiff = xhTime.getTime() - newDate.getTime();
            let topMinutes=Math.floor(dateDiff/(60*1000));
            timeIntervalList[timeIntervalList.length-1].minutesInterval = topMinutes;
          }
          if(pageUtils.dateFormat(nightStartTime, "yyyy-MM-dd HH:mm") <= pageUtils.dateFormat(xhTime, "yyyy-MM-dd HH:mm") && pageUtils.dateFormat(nightStartTime, "yyyy-MM-dd HH:mm") > pageUtils.dateFormat(newDate, "yyyy-MM-dd HH:mm")) {
            xhTime = nightStartTime;
            let dateDiff = xhTime.getTime() - newDate.getTime();
            let topMinutes=Math.floor(dateDiff/(60*1000));
            timeIntervalList[timeIntervalList.length-1].minutesInterval = topMinutes;
          }
        }
        this.timeIntervalList = timeIntervalList;
      }
    },
    /**
     * 计算已排课时
     */
    countCoursePlanHour:function(){
      var that = this;
      var courseList = this.courseList;
      var scheduleData = this.scheduleData;
      var childPageJsonArr = [];
      var courseMap = {};
      scheduleData.forEach((scheduleOne, xhIndex) => {
        var scheduleCourseId = scheduleOne.SCHEDULE_COURSE_ID;
        if(!courseMap["COURSE_"+scheduleCourseId]) {
          courseMap["COURSE_"+scheduleCourseId] = 0;
        }
        courseMap["COURSE_"+scheduleCourseId] = courseMap["COURSE_"+scheduleCourseId] + scheduleOne.HOUR;
      });
      var orderMap = {}
      courseList.forEach((courseOne, xhIndex) => {
        // courseOne.COURSE_PLAN_HOUR = courseMap["COURSE_"+courseOne[this.courseIdKey]]?courseMap["COURSE_"+courseOne[this.courseIdKey]]:0;
        that.$set(courseOne,"COURSE_PLAN_HOUR", courseMap["COURSE_"+courseOne[this.courseIdKey]]?courseMap["COURSE_"+courseOne[this.courseIdKey]]:0);
        var orderNum = courseOne.ORDER_NUM;
        //获取订单编号 获取订单的已排课时 ORDER_NUM
        if(!orderMap["ORDER_NUM_"+orderNum]) {
          orderMap["ORDER_NUM_"+orderNum] = 0;
        }
        orderMap["ORDER_NUM_"+orderNum] += courseOne.COURSE_PLAN_HOUR*1;
        
      });
      courseList.forEach((courseOne, xhIndex) => {
        var orderNum = courseOne.ORDER_NUM;
        if(orderNum) {
          that.$set(courseOne,"ORDER_PLAN_HOUR", orderMap["ORDER_NUM_"+orderNum]?orderMap["ORDER_NUM_"+orderNum]:0);
        } else {
          that.$set(courseOne,"ORDER_PLAN_HOUR", courseOne.COURSE_PLAN_HOUR?courseOne.COURSE_PLAN_HOUR:0);
        }
      });
      this.courseList = courseList;
      var value = this.value;
      var scheduleField = value.fieldSet[this.scheduleIndex];
      scheduleField.defaultCheckDataList = scheduleData;
      // that.$emit("changeScheduleData",value,that.filedIndex)
      pageUtils.confirmDialogCallBack(that,scheduleField, that.filedIndex, true);
      console.log("scheduleField==============================",scheduleField);
    },
    refreshScheduleData:function(){
      var that = this;
      var scheduleData = this.scheduleData;
      var value = this.value;
      var scheduleField = value.fieldSet[this.scheduleIndex];
      scheduleField.defaultCheckDataList = scheduleData;
      // that.$emit("changeScheduleData",value,that.filedIndex)
      pageUtils.confirmDialogCallBack(that,scheduleField, that.filedIndex, true);
      console.log("保存前刷新----------refreshScheduleData-----------");
    },
    /**
     * 打开或关闭添加时段弹出层
     */
    toAddTimeIntervalOne:function(initTimeStr){
      console.log("toAddTimeIntervalOne========================");
      this.ifTimeSetDialog.flag = !this.ifTimeSetDialog.flag;
      var setData = this.setData;
      if(this.ifTimeSetDialog.flag) {
        if(initTimeStr) {
          this.ifTimeSetDialog.startDate = initTimeStr.split("-")[0];
          this.ifTimeSetDialog.endDate = initTimeStr.split("-")[1];
        } else {
          this.ifTimeSetDialog.startDate = setData.startTime;
          this.ifTimeSetDialog.endDate = setData.endTime;
        }
      }
    },
    /**
     * 添加一个时段
     */
    addTimeIntervalOne:function(){
      var that = this;
      var setData = this.setData;
      var toAddTimeStr = this.toAddTime;
      var toAddTime = new Date("2020-01-01 " + toAddTimeStr);
      var timeIntervalList = this.timeIntervalList;
      var addIndex = -1;
      var minutesInterval = 0;
      var topMinutes = 0;
      timeIntervalList.forEach((timeIntervalOne, xhIndex) => {
        var xhTimeDate = new Date(timeIntervalOne.xhTime);
        var xhTimeStr = pageUtils.dateFormat(xhTimeDate, "HH:mm");;
        if(toAddTimeStr > xhTimeStr) {
          addIndex = xhIndex;
          let dateDiff =toAddTime.getTime() - xhTimeDate.getTime();
          topMinutes=Math.floor(dateDiff/(60*1000));
          minutesInterval = timeIntervalOne.minutesInterval - topMinutes;
        }
        if(toAddTimeStr == xhTimeStr) {
          addIndex = -2;
        }
      });
      console.log("addIndex=====================",addIndex,toAddTimeStr,toAddTime);
      if(addIndex >= 0) {
        timeIntervalList[addIndex].minutesInterval = topMinutes;
        timeIntervalList.splice(addIndex+1, 0, {
          xhTime:pageUtils.dateFormat(toAddTime, "yyyy-MM-dd HH:mm"),
          minutesInterval:minutesInterval
        });
        if(setData.rowHeight*((topMinutes<minutesInterval?topMinutes:minutesInterval)/setData.minutesInterval)<37) {
          setData.rowHeight = 37*(setData.minutesInterval/(topMinutes<minutesInterval?topMinutes:minutesInterval));
        }
        that.loadTableData();
      }
      this.toAddTimeIntervalOne();
    },
    /**
     * 去删除一个时段
     */
    toDeleteTimeIntervalOne:function(index){
      var setData = this.setData;
      var minutesInterval = this.timeIntervalList[index].minutesInterval;
      this.timeIntervalList.splice(index, 1); 
      if(index > 0) {
        this.timeIntervalList[index-1].minutesInterval = this.timeIntervalList[index-1].minutesInterval+minutesInterval;
      }
      setData.rowHeight = 100;
      this.timeIntervalList.forEach(element => {
        if(100*((element.minutesInterval)/setData.minutesInterval)<37) {
          var minRowHeight = 37*(setData.minutesInterval/(element.minutesInterval));
          if(minRowHeight > setData.rowHeight) {
            setData.rowHeight = minRowHeight;
          }
        }
      });
      this.loadTableData();
    },
    /**
     * 点击时 进行排课或者取消操作
     */
    clickCheckBox:function(value, column, row){
      var that = this;
      var setData = this.setData;
      var scheduleData = this.scheduleData;
      var courseList = this.courseList;
      var currentRowIndex = this.currentRowIndex;
      var courseOne = courseList[currentRowIndex];
      var studyDate = "";
      var startEndTime = "";
      if(setData.hvType) {
        // 时段作为表头行
        
      } else {
        // 日期作为表头行
        studyDate = column.date;
        startEndTime = row.timeInterval;
      }
      var startTime = startEndTime.split("-")[0];
      var startTimeStr = studyDate + " " + startTime;
      var minutesLength = setData.minutesLength;
      var minutesInterval = setData.minutesInterval;
      var startDate_date = new Date(startTimeStr);
      // 判断是 排课 还是取消排课
      if(value) {
        minutesLength = courseOne.COURSE_MINUTES_LENGTH*(courseOne.COURSE_BOUT_HOUR*1);
        //获取需要排的课程
        startDate_date.setMinutes(startDate_date.getMinutes()+minutesLength);
        var endTimeStr = pageUtils.dateFormat(startDate_date, "yyyy-MM-dd HH:mm");
        // 排课  排课时校验课程是否已经存在 是否已经时间冲突
        var shceduleOne = {
          "SCHEDULE_COURSE_ID":courseOne[that.courseIdKey],
          "SCHEDULE_COURSE_NAME":courseOne.COURSE_NAME,
          "SCHEDULE_TEA_ID":courseOne.TEA_ID,
          "SCHEDULE_TEA_NAME":courseOne.TEA_NAME,
          "SCHEDULE_ROOM_ID":courseOne.ROOM_ID,
          "SCHEDULE_ROOM_NAME":courseOne.ROOM_NAME,
          "STUDY_DATE":studyDate,
          "START_DATE":startTimeStr,
          "END_DATE":endTimeStr,
          "MINUTES":minutesLength,
          "HOUR":(courseOne.COURSE_BOUT_HOUR*1)
        };
        var ifAddFlag = that.addScheduleDataOne(scheduleData,shceduleOne);
      } else {
        startDate_date.setMinutes(startDate_date.getMinutes()+minutesInterval);
        var endTimeStr = pageUtils.dateFormat(startDate_date, "yyyy-MM-dd HH:mm");
        // 取消排课
        for (let index = 0; index < scheduleData.length; ) {
          const scheduleOne = scheduleData[index];
          var scheduleStudyDate = scheduleOne.STUDY_DATE;
          var scheduleStartDate = scheduleOne.START_DATE;
          var scheduleEndDate = scheduleOne.END_DATE;
          var scheduleMinutes = scheduleOne.MINUTES;
          var scheduleHeight = setData.rowHeight*(scheduleMinutes/setData.minutesInterval);
          //判断时段在当前的表格内
          var scheduleStartDateStr = pageUtils.dateFormat(new Date(scheduleStartDate), "yyyy-MM-dd HH:mm");
          if(!(startTimeStr >= scheduleEndDate || endTimeStr <= scheduleStartDateStr)) {
            // 数组中删除元素
            scheduleData.splice(index,1);
          } else {
            index++;
          } 
        }
      }
      console.log("scheduleData===================111=============",scheduleData);
      that.scheduleData = scheduleData;
      that.loadTableData();
    },
    //打开单次课程的页面设置,可以选择教室信息
    changeScheduleRoom:function(column, row){
      var that = this;
      console.log("column, row================",column, row);
      console.log("scheduleData================",this.scheduleData);
      var studyDate = column.date;
      var scheduleIndex = row['index_'+studyDate];
      that.changeScheduleRoomByIndex(scheduleIndex,0);
    },
    changeScheduleRoomByIndex:function(scheduleIndex,openType){
      var that = this;
      if(that.dataInfo.ROOM_CHOOSE_PAGE_ID > 0 && that.dataInfo.ROOM_CHOOSE_TABLE_ID > 0) {
        var scheduleOne = that.scheduleData[scheduleIndex];
        //加载本课程空闲的可用的教室信息
        var ajaxListUrl = 'model_ajaxList.do';
        var toHtData = {};
        toHtData.start = 0;
        toHtData.limit = 10000;
        //tableId 表id
        toHtData.tableId = that.dataInfo.ROOM_CHOOSE_TABLE_ID;
        //pageId 页面id
        toHtData.pageId = that.dataInfo.ROOM_CHOOSE_PAGE_ID;
        toHtData.ifAjax = 1;
        toHtData.freeTime_6_andOr = 0;
        toHtData.startDate_startDates_pld = scheduleOne.STUDY_DATE;
        toHtData.endDate_endDates_pld = scheduleOne.STUDY_DATE;
        toHtData.startTime_startDates_pld = scheduleOne.START_DATE.split(" ")[1];
        toHtData.endTime_endDates_pld = scheduleOne.END_DATE.split(" ")[1];
        toHtData.startWeek_startDates_pld = 1;
        toHtData.endWeek_startDates_pld = 7;
        //后台请求  加载教师的时间占用信息
        utils.request(that, {
          url: ajaxListUrl, //读取列表数据的接口
          data: toHtData,
          success: function (res) {
            var pageDataInfo = res.data.rows;
            if(!scheduleOne.SCHEDULE_ROOM_ID) {
              that.$set(scheduleOne,"SCHEDULE_ROOM_ID",scheduleOne.SCHEDULE_ROOM_ID);
            }
            var roomData = [];
            var ifOpen = true;
            pageDataInfo.forEach(element => {
              if(element.USE_TIME_COUNT == 0 || (openType == 0 && (element["T_"+toHtData.tableId+"_0"]==scheduleOne.SCHEDULE_ROOM_ID))) {
                roomData.push(element);
              }
              if((element["T_"+toHtData.tableId+"_0"]==scheduleOne.SCHEDULE_ROOM_ID) && element.USE_TIME_COUNT == 0 && openType == 1) {
                ifOpen = false;
              } else if((element["T_"+toHtData.tableId+"_0"]==scheduleOne.SCHEDULE_ROOM_ID) && element.USE_TIME_COUNT > 0 && openType == 1) {
                //当前教室冲突 进行去除
                that.$set(scheduleOne,"SCHEDULE_ROOM_ID","");
                that.$set(scheduleOne,"SCHEDULE_ROOM_NAME","");
                that.loadTableData();
              }
            });
            that.nowOpenRoomScheduleInfo.roomData = roomData;
            // that.loadTableData();
            that.nowOpenRoomScheduleInfo.ifLoad = ifOpen;
            that.nowOpenRoomScheduleInfo.scheduleIndex = scheduleIndex;
          }
        })
      }
    },
    roomChange:function(value){
      var roomName = "";
      this.nowOpenRoomScheduleInfo.roomData.forEach(element => {
        if(element['T_'+this.dataInfo.ROOM_CHOOSE_TABLE_ID+'_0'] == value) {
          roomName = element.ROOM_NAME;
        }
      });
      this.scheduleData[this.nowOpenRoomScheduleInfo.scheduleIndex].SCHEDULE_ROOM_NAME = roomName;
      this.loadTableData();
    },
    confirmChangeScheduleRoom:function(){
      this.nowOpenRoomScheduleInfo.ifLoad = false;
    },
    closeChangeScheduleRoom:function(){
      this.nowOpenRoomScheduleInfo.ifLoad = false;
    },
    /**
     * 增加一条排课记录 进行排课校验
     */
    addScheduleDataOne:function(scheduleData,addOne){
      var that = this;
      var ifAddFlag = true;
      var startTimeStr = addOne.START_DATE;
      var endTimeStr = addOne.END_DATE;
      console.log("scheduleData==================",scheduleData,addOne);
      scheduleData.forEach((scheduleOne, xhIndex) => {
        var scheduleStartDate = scheduleOne.START_DATE;
        var scheduleEndDate = scheduleOne.END_DATE;
        //判断时段在当前的表格内
        if(!(startTimeStr >= scheduleEndDate || endTimeStr <= scheduleStartDate)) {
          ifAddFlag = false;
        }
      });
      var teaIfAddFlag = that.checkTeaTimeResource("TEA",startTimeStr,endTimeStr);
      var message = "";
      if(!teaIfAddFlag) {
        ifAddFlag = false;
        message = "时间冲突不可排!";
      }
      var roomIfAddFlag = that.checkTeaTimeResource("ROOM",startTimeStr,endTimeStr);
      if(!roomIfAddFlag) {
        ifAddFlag = false;
        message = "教室冲突不可排!";
      }
      //判断 已排课时小于总课时
      var hourIfAddFlag = that.checkHourAdequate(addOne);
      if(!hourIfAddFlag) {
        ifAddFlag = false;
        message = "课时数不够不可排!";
      } 
      if(ifAddFlag) {
        scheduleData.push(addOne);
        that.changeScheduleRoomByIndex(scheduleData.length-1,1);
      } else {
        alert(message);
      }
      return ifAddFlag;
    },
    /**
     * 当前排那门课程
     */
    courseCurrentChange:function(val){
      this.currentRowIndex = val;
      this.getTeaTimeResource("TEA");
      this.getTeaTimeResource("ROOM");
    },
    /**
     * 教师弹出层切换教师时 进行教师切换
     */
    teaChangeCallBack:function(fieldOne,courseIndex){
      var courseList = this.courseList;
      courseList[courseIndex].TEA_ID = fieldOne.defaultCheckValue;
      courseList[courseIndex].TEA_NAME = fieldOne.defaultCheckCnName;
      this.getTeaTimeResource("TEA");
      console.log("this.value=====================",this.value);
    },
    /**
     * 教室弹出层切换教室时 进行教室切换
     */
    roomChangeCallBack:function(fieldOne,courseIndex){
      var courseList = this.courseList;
      courseList[courseIndex].ROOM_ID = fieldOne.defaultCheckValue*1;
      courseList[courseIndex].ROOM_NAME = fieldOne.defaultCheckCnName;
      this.getTeaTimeResource("ROOM");
    },
    /**
     * 获取人员时间资源信息
     */
    getTeaTimeResource:function(type){
      var that = this;
      console.log("that.dataInfo---------------",that.dataInfo);
      if((type=='TEA' && that.dataInfo.TEA_PAGE_ID > 0 && that.dataInfo.TEA_TABLE_ID > 0) || (type=='ROOM' && that.dataInfo.ROOM_PAGE_ID > 0 && that.dataInfo.ROOM_TABLE_ID > 0)) {
        var currentRowIndex = this.currentRowIndex;
        var courseList = this.courseList;
        var courseOne = courseList[currentRowIndex];
        var teaTimeSource = null;
        var checkId = "";
        if(type=='ROOM') {
          teaTimeSource = this.roomTimeSource;
          checkId = courseOne.ROOM_ID;
        } else {
          teaTimeSource = this.teaTimeSource;
          checkId = courseOne.TEA_ID;
        }

        console.log("type---------------",type,checkId);
        if(checkId != null && checkId != "" && checkId != undefined) {
          var teaIdArr = (checkId+"").split(",");
          for (let index = 0; index < teaIdArr.length; index++) {
            const teaId = teaIdArr[index];  
            if(teaId > 0) { // && !teaTimeSource["TEA_"+teaId]
              teaTimeSource["TEA_"+teaId] = [];
            }
          }
          var ajaxListUrl = 'model_ajaxList.do';
          var toHtData = {};
          toHtData.start = 0;
          toHtData.limit = 10000;
          if(type=='ROOM') {
            //tableId 表id
            toHtData.tableId = that.dataInfo.ROOM_TABLE_ID;
            //pageId 页面id
            toHtData.pageId = that.dataInfo.ROOM_PAGE_ID;
          } else {
            //tableId 表id
            toHtData.tableId = that.dataInfo.TEA_TABLE_ID;
            //pageId 页面id
            toHtData.pageId = that.dataInfo.TEA_PAGE_ID;
          }
          toHtData.ifAjax = 1;
          toHtData.USER_ID_4_dicCond_pld = 0;
          toHtData.USER_ID_4_andOr = 0;
          toHtData.USER_ID_searchEleId = checkId;
          toHtData.DATE_3_andOr = 0;
          toHtData.DATE_dateType = "yyyy-MM-dd";
          toHtData.DATE_startDates_pld = pageUtils.dateFormat(that.setData.startDate, "yyyy-MM-dd");
          toHtData.DATE_endDates_pld = pageUtils.dateFormat(that.setData.endDate, "yyyy-MM-dd");
          //后台请求  加载教师的时间占用信息
          utils.request(that, {
            url: ajaxListUrl, //读取列表数据的接口
            data: toHtData,
            success: function (res) {
              var pageDataInfo = res.data.rows;
              pageDataInfo.forEach(element => {
                var tmpTeaId = element.MAIN_DATA_ID;
                teaTimeSource["TEA_"+tmpTeaId].push(element);
              });
              that.loadTableData();
            }
          })
        }
      }
    },
    /**
     * 显示教师的时间资源
     */
    showTeaTimeResource:function(type,tableDataOne,startTimeStr,endTimeStr){
      var that = this;
      var setData = that.setData;
      var currentRowIndex = this.currentRowIndex;
      var courseList = this.courseList;
      var courseOne = courseList[currentRowIndex];
      var teaTimeSource = null;
      var checkId = "";
      if(type=='ROOM') {
        teaTimeSource = this.roomTimeSource;
        checkId = courseOne.ROOM_ID;
      } else {
        teaTimeSource = this.teaTimeSource;
        checkId = courseOne.TEA_ID;
      }
      if(checkId != null && checkId != "" && checkId != undefined) {
        var teaIdArr = (checkId+"").split(",");
        for (let index = 0; index < teaIdArr.length; index++) {
          const teaId = teaIdArr[index];  
          const teaOneTimeSource = teaTimeSource["TEA_"+teaId];
          // console.log("teaOneTimeSource====================",teaOneTimeSource);
          if(teaId > 0 && teaOneTimeSource) {
            //已排课时间段进行表格显示
            teaOneTimeSource.forEach((scheduleOne, xhIndex) => {
              var scheduleStudyDate = scheduleOne.STUDY_DATE;
              var scheduleStartDate = scheduleOne.START_DATE;
              var scheduleMinutes = scheduleOne.MINUTES;
              var scheduleEndDate = scheduleOne.END_DATE;
              var scheduleTimeStr = pageUtils.dateFormat(new Date(scheduleStartDate), "HH:mm") + "-" + pageUtils.dateFormat(new Date(scheduleEndDate), "HH:mm");
              var scheduleHeight = setData.rowHeight*(scheduleMinutes/setData.minutesInterval);
              //判断时段在当前的表格内
              var scheduleStartDateStr = pageUtils.dateFormat(new Date(scheduleStartDate), "HH:mm");
              // if(scheduleOne.STUDY_DATE == "2021-07-29") {
              //   console.log("scheduleStartDateStr=================",scheduleStartDateStr,startTimeStr,endTimeStr,tableDataOne["date_"+scheduleStudyDate]);
              // }
              if(scheduleStartDateStr >= startTimeStr && scheduleStartDateStr < endTimeStr && !tableDataOne["date_"+scheduleStudyDate]) {
                tableDataOne["if_date_"+scheduleStudyDate] = true;
                tableDataOne["date_"+scheduleStudyDate] = (scheduleOne["SCHEDULE_COURSE_NAME"]?scheduleOne["SCHEDULE_COURSE_NAME"]:"") + " " + scheduleStudyDate + " " + scheduleTimeStr  + " " + (scheduleOne["SCHEDULE_TEA_NAME"]&&scheduleOne["SCHEDULE_TEA_NAME"]!='undefined'?scheduleOne["SCHEDULE_TEA_NAME"]:"") + " " + (scheduleOne["SCHEDULE_ROOM_NAME"]&&scheduleOne["SCHEDULE_ROOM_NAME"]!='undefined'?scheduleOne["SCHEDULE_ROOM_NAME"]:"");
                tableDataOne["height_date_"+scheduleStudyDate] = scheduleHeight;
                tableDataOne["check_date_"+scheduleStudyDate] = false;
                //距离顶部的距离 top
                var scheduleTop = 0;
                if(scheduleStartDateStr != startTimeStr) {
                  let dateDiff = new Date('2021-01-01 '+scheduleStartDateStr).getTime() - new Date('2021-01-01 '+startTimeStr).getTime();
                  let topMinutes=Math.floor(dateDiff/(60*1000));
                  scheduleTop = setData.rowHeight*(topMinutes/setData.minutesInterval);
                }
                tableDataOne["top_date_"+scheduleStudyDate] = scheduleTop;
                tableDataOne["ZD_IF_LEAVE_date_"+scheduleStudyDate] = scheduleOne.ZD_IF_LEAVE;
              }
            });
          }
        }
      }
    },
    /**
     * 检查跟教师的时间是否冲突
     */
    checkTeaTimeResource(type,startTimeStr,endTimeStr) {
      var that = this;
      var ifAddFlag = true;
      var setData = that.setData;
      var currentRowIndex = this.currentRowIndex;
      var courseList = this.courseList;
      var courseOne = courseList[currentRowIndex];
      var teaTimeSource = null;
      var checkId = "";
      if(type=='ROOM') {
        teaTimeSource = this.roomTimeSource;
        checkId = courseOne.ROOM_ID;
      } else {
        teaTimeSource = this.teaTimeSource;
        checkId = courseOne.TEA_ID;
      }
      if(checkId != null && checkId != "" && checkId != undefined) {
        var teaIdArr = (checkId+"").split(",");
        for (let index = 0; index < teaIdArr.length; index++) {
          const teaId = teaIdArr[index];  
          const teaOneTimeSource = teaTimeSource["TEA_"+teaId];
          if(teaId > 0 && teaOneTimeSource) {
            //已排课时间段进行表格显示
            teaOneTimeSource.forEach((scheduleOne, xhIndex) => {
              var scheduleStartDate = scheduleOne.START_DATE;
              var scheduleEndDate = scheduleOne.END_DATE;
              var ZD_IF_LEAVE = scheduleOne.ZD_IF_LEAVE;
              console.log("ZD_IF_LEAVE==================",ZD_IF_LEAVE);
              //判断时段在当前的表格内
              if(!(startTimeStr >= scheduleEndDate || endTimeStr <= scheduleStartDate) && ZD_IF_LEAVE != 1) {
                ifAddFlag = false;
              }
            });
          }
        }
      }
      return ifAddFlag;
    },
    /**
     * 检测课时是否充足
     */
    checkHourAdequate(addOne) {
      var that = this;
      var ifAddFlag = true;
      var currentRowIndex = this.currentRowIndex;
      var courseList = this.courseList;
      var courseOne = courseList[currentRowIndex];
      if((courseOne.ORDER_PLAN_HOUR*1+addOne.HOUR*1) <= courseOne.COURSE_MAX_HOUR*1) {

      } else {
        ifAddFlag = false
      }
      return ifAddFlag;
    }
  }
}
        
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
